
  import {shuffleArray} from '@/helper/ArrayHelper';

  export default {
    name: 'RelatedEvents',
    filters: {
      truncate(string, value) {
        return string.length > value
          ? string.substring(0, value) + '…'
          : string;
      },
    },
    props: {
      event: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        selectedItem: {},
        relatedEvents: [],
        organizationScope: process.env.SCOPE_ORGANIZATION,
      };
    },
    async fetch() {
      const related_event_ids = [];

      this.event.related_events.forEach((element) => {
        if (
          !related_event_ids.includes(element.id) &&
          element.id !== this.event.id
        ) {
          related_event_ids.push(element.id);
        }
      });

      if (this.event.relation_tags) {
        const relation_tags_structured = this.event.relation_tags
          .split(',')
          .map((x) => ['relation_tags_contains', x.trim()]);
        relation_tags_structured.push(['scope_contains', this.event.scope]);

        const relatedEventsByRelationTag = await this.$strapi.find(
          'events',
          relation_tags_structured
        );

        relatedEventsByRelationTag.forEach((element) => {
          if (
            !related_event_ids.includes(element.id) &&
            element.id !== this.event.id
          ) {
            related_event_ids.push(element.id);
          }
        });
      }

      if (related_event_ids.length > 0) {
        const related_events_search_params = [
          ['scope_contains', this.event.scope],
        ];
        related_event_ids.forEach((element) => {
          related_events_search_params.push(['id_in', element]);
        });

        this.relatedEvents = await this.$strapi.find(
          'events',
          related_events_search_params
        );
        this.relatedEvents = shuffleArray(this.relatedEvents).slice(0, 5);
      }
    },
  };
